export default __webpack_public_path__ + "static/media/arrow-icon2.0e46bbf1.png";